/**
 * MineraliA: comportamiento del botón flotante de WhatsApp (snippets/mineralia-whatsapp-float.liquid).
 *
 * Todo funciona sin este script: los temas son enlaces `wa.me` y el formulario hace GET a `wa.me`.
 * Este módulo sólo:
 * - antepone `data-wa-context` (p. ej. la pieza) al texto libre de `form[data-wa-form]`;
 * - cierra el popover del que sale el clic;
 * - publica `mineralia:whatsapp_click` ({ topic, source, page }) para un píxel personalizado.
 */

const EVENT_NAME = 'mineralia:whatsapp_click';

/**
 * @param {string} topic
 * @param {Element} origin
 */
function track(topic, origin) {
  try {
    window.Shopify?.analytics?.publish?.(EVENT_NAME, {
      topic,
      source: origin.closest('[data-wa-source]')?.getAttribute('data-wa-source') || 'desconocido',
      page: location.pathname,
    });
  } catch (error) {
    // La analítica nunca debe impedir abrir WhatsApp.
  }
}

/** @param {Element} origin */
function closePopover(origin) {
  const popover = origin.closest('[popover]');
  if (popover instanceof HTMLElement && popover.matches(':popover-open')) popover.hidePopover();
}

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('[data-wa-topic]') : null;
  if (!link) return;
  track(link.getAttribute('data-wa-topic') || '', link);
  closePopover(link);
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-wa-form')) return;

  const input = form.querySelector('[name="text"]');
  if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)) return;
  const text = input.value.trim();
  if (!text) return;

  event.preventDefault();
  const context = form.getAttribute('data-wa-context') || '';
  const message = context ? `${context}\n${text}` : text;
  window.open(`${form.action}?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
  track('mensaje libre', form);
  input.value = '';
  closePopover(form);
});

document.addEventListener(
  'toggle',
  (event) => {
    const panel = event.target;
    if (!(panel instanceof HTMLElement) || !panel.hasAttribute('data-wa-source')) return;
    if (/** @type {ToggleEvent} */ (event).newState === 'open') track('abrir panel', panel);
  },
  true
);
